export default __webpack_public_path__ + "i18n/languages.0455123.json";